import { RESET_FORM } from '../actionTypes';
import { chatActions } from '../reducer';

export default () => chatActions[RESET_FORM]();
